import {CustomerDialogLayout} from '@modifi/ui'
import {DialogManager} from '@modifi/plugin-dialogs'

DialogManager.setDefaultLayout(CustomerDialogLayout)
